import { Stack, Button, IconButton, Tooltip, TextField, Box, Typography, FormControlLabel, Select, FormControl, InputLabel, MenuItem, Divider } from "@mui/material";
import { useContext, useState, useEffect, ChangeEvent, useCallback } from "react";
import styled from 'styled-components';
import Table from '../custom/Table';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { BILLING_ADDRESS_DETAILS_FORM, INV_RGP_COLUMN, InventoryData, MyObject, SHIPPING_ADDRESS_DETAILS_FORM, TransactionDetail } from "../../Models/Inventory";
import Modal from '../Modals';
import useService from '../../hooks/useService';
import { InventoryContext } from "../../contexts/InventoryContext";
import { ShowSerialNumbers, ShowTranscationDetails, getInventoryType } from "./InventoryShowcase";
import { createRGPTransferOrder, fetchStoInventory, searchRGPCustomer } from "../../services/Inventory";
import { AuthContext } from "../../contexts/AuthContext";
import { GridColDef, GridRowSelectionModel, GridRowParams, GridRenderCellParams, GridToolbar, DataGrid, GridFilterModel } from '@mui/x-data-grid';
import { Theme } from '@mui/material/styles';
import { NotificationContext } from "../../contexts/NotificationContext";
import { RGPStockModal } from "../../utils/constant";
import DynamicForm, { useDynamicForm } from '../forms/DynamicFormNew';
import Checkbox from '@mui/material/Checkbox';
import SelectCustomer from "../$SelectCustomer";
import { CustomerContext } from "../../contexts/CustomerContext";
import AddressCard from "../custom/AddressCard";

const SerialNumberGrid = styled.div`
  width: 900px !important;
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
`
export const TextFieldGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
  width: 100%;
`
export const MetalImage = styled.img`
  object-fit: contain;
  max-width: 100px;
  max-height: 45px;
  border-radius: 4px;
  padding: 3px 0;
`
export const Typographyfield = styled(Typography)`
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  padding: 10px;
`
export const TypographyValue = styled(Typography)`
  color: #333E48;
  font-size: 18px !important;
  font-style: normal;
  font-weight: bold !important;
  padding: 10px;
`
const DropdownRow = styled.div`
  width: 800px;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
`
const Toggle = styled.div`
  display: flex;
  margin-left: 25px;
`
interface RGPModalProps {
    onClose: () => any;
    reloadRGPData: Function
}
interface DestinationId {
    value: string,
    label: string
}

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export function getStyles(name: number, personName: readonly number[], theme: Theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}


const CreateRGPModal = ({ onClose, reloadRGPData }: RGPModalProps) => {
    const { user } = useContext(AuthContext)
    const { stoInventories, getRGPCustomerAddress, setRGPCustomerAddress } = useContext(InventoryContext)
    const { customerAddresses, setCustomerAddresses } = useContext(CustomerContext)
    const { notify } = useContext(NotificationContext);
    const { execute } = useService()

    const [remarks, setRemarks] = useState<string>('')
    const [totalGoldFineWeight, setTotalGoldFineWeight] = useState<number>(0)
    const [totalSilverFineWeight, setTotalSilverFineWeight] = useState<number>(0)

    const [showSerialNumberModal, setShowSerialNumberModal] = useState<boolean | InventoryData>(false)
    const [showTranscationDetail, setShowTranscationDetail] = useState<boolean | TransactionDetail>(false)
    const [selectSerialNumberModal, setSelectSerialNumberModal] = useState<boolean | InventoryData>(false)

    const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);
    const [rows, setRows] = useState<InventoryData[]>(stoInventories?.data as InventoryData[]);

    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 })
    const [filterModel, setFilterModel] = useState<GridFilterModel>({
        items: []
    })

    const [isShippingBillingAddressSame, setShippingBillingAddressSame] = useState<boolean>(true)
    const [isExistingCustomerSelected, setExistingCustomerSelected] = useState<boolean>(true)
    const [billingAddressId, setBillingAddressId] = useState<string>('')
    const [shippingAddressId, setShippingAddressId] = useState<string>('')

    const [userAddress, setUserAddress] = useState({ billingAddress: {}, shippingAddress: {} })

    const [showCustomerModal, setShowCustomerModal] = useState(false)
    const [customerName, setCustomerName] = useState<string>('')
    const [mobileNumber, setMobileNumber] = useState<string>('')
    const [createNewAddress, setCreateNewAddress] = useState(false)

    const clearAllPreviousState = () => {
        setRowSelectionModel([])
        clearPreviousRowDetails()
        setRemarks('')
    }

    const closeTranscationDetailModal = () => {
        setShowTranscationDetail(false)
    }

    const closeSerialNumberModal = () => {
        setShowSerialNumberModal(false)
    }

    const closeSelectSerialNumberModal = () => {
        setSelectSerialNumberModal(false)
    }

    const getTotalFineWeight = (updatedRows: InventoryData[]) => {
        updatedRows.forEach((row: InventoryData) => {
            if (row.metalType.toLowerCase() === 'gold') {
                let total = 0
                let totaMetalWeight = 0
                for (let i = 0; i <= updatedRows.length; i++) {
                    let goldFineWeight = updatedRows[i]?.goldFineWeight || 0
                    total = total + goldFineWeight
                    total = Number(total)
                    setTotalGoldFineWeight(total)

                    let totalWeight = updatedRows[i]?.transferredWeight || 0
                    totaMetalWeight = Number(totaMetalWeight) + Number(totalWeight)
                    totaMetalWeight = Number(totaMetalWeight)
                }
            } else {
                let total = 0
                let totaMetalWeight = 0
                for (let i = 0; i <= updatedRows.length; i++) {
                    let silverFineWeight = updatedRows[i]?.silverFineWeight || 0
                    total = total + silverFineWeight
                    total = Number(total)
                    setTotalSilverFineWeight(total)

                    let totalWeight = updatedRows[i]?.transferredWeight || 0
                    totaMetalWeight = Number(totaMetalWeight) + Number(totalWeight)
                    totaMetalWeight = Number(totaMetalWeight)
                }
            }
        })
    }

    const handleQuantityTransfer = (Q: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, params: InventoryData) => {
        let value = Number(Q?.target?.value) || Number(Q)
        if (value < 0) value = 0

        let updatedRows: InventoryData[] = []
        let transferredWeight = 0
        let fineWeight = 0

        rows.forEach((row: InventoryData) => {
            if (params.id === row.id) {
                let { inventoryType, metalType, quantity, currentWeight, currentFineWeight, serialNumbers } = row

                if (value > quantity) value = quantity

                row['transferredQuantity'] = value

                transferredWeight = (currentWeight / quantity) * value
                row['transferredWeight'] = Number(transferredWeight)

                fineWeight = (currentFineWeight / quantity) * value
                row['fineWeightChange'] = Number(fineWeight)

                // if(inventoryType === 1) {
                //   row['selectedSerialNumbers'] = serialNumbers.slice(0, value)
                //   row['selectedRowIds'] = serialNumbers.slice(0, value).map((vl: number, idx: number) => idx)
                // }

                if (metalType.toLowerCase() === 'gold') {
                    row['goldFineWeight'] = fineWeight as number
                } else {
                    row['silverFineWeight'] = fineWeight as number
                }
                updatedRows.push(row)
            } else {
                updatedRows.push(row)
            }
        })
        getTotalFineWeight(updatedRows as InventoryData[])
        setRows(updatedRows as InventoryData[])
    }

    const handleWeightTransfer = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, params: InventoryData) => {
        e.stopPropagation()
        let value = Number(e.target.value)
        if (value < 0) value = 0

        let updatedRows: InventoryData[] = []
        let transferredWeight = 0
        let fineWeight = 0

        rows.forEach((row: InventoryData) => {
            let { id, inventoryType, currentWeight, metalType, purity, currentFineWeight, quantity } = row

            if (params.id === id) {
                if (inventoryType !== 3 && value > Number(currentWeight)) {
                    transferredWeight = currentWeight
                } else {
                    transferredWeight = value
                }

                fineWeight = (value * Number(purity)) / 1000
                fineWeight = Number(fineWeight)

                if (params.inventoryType === 3) {
                    fineWeight = (Number(currentFineWeight) * value) / currentWeight
                    fineWeight = Number(fineWeight)
                }

                row['transferredWeight'] = transferredWeight
                row['fineWeightChange'] = fineWeight
                // row['transferredQuantity'] = quantity

                if (metalType.toLowerCase() === 'gold') {
                    row['goldFineWeight'] = fineWeight as number
                } else {
                    row['silverFineWeight'] = fineWeight as number
                }
                updatedRows.push(row)
            } else {
                updatedRows.push(row)
            }
        })

        getTotalFineWeight(updatedRows as InventoryData[])
        setRows(updatedRows as InventoryData[])
    }

    const handleRemarks = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, params: GridRenderCellParams) => {
        let value = e.target.value
        setRows((prev: any) => prev.map((row: any) => {
            return params.row.id === row.id ? { ...row, 'remarks': value } : row
        }))
    }

    const getInventoryColumns = () => {
        let minWidth = 300

        let columnToShowCase = INV_RGP_COLUMN

        return columnToShowCase.map(inboundField => {

            const row: GridColDef = {
                field: inboundField.id,
                headerName: inboundField.label,
                minWidth,
                align: 'left',
                editable: false,
                headerAlign: 'left'
            }

            switch (inboundField.id) {
                case "image":
                    row.minWidth = 100;
                    row.filterable = false;
                    row.renderCell = params => {
                        let url = params.row.images.length > 0 ? params.row.images.sort((a: MyObject, b: MyObject) => Number(a.priority) - Number(b.priority))[0].img_url : ''
                        return url ? <MetalImage src={url} /> : <MetalImage src={'/assets/images/elementor-placeholder-image.webp'} />
                    }
                    break;
                case "name":
                    row.minWidth = 550;
                    row.type = 'string';
                    row.filterable = false;
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.name ? params.row.name : "NA"}>
                                <Typography>{params.row.name ? params.row.name : "NA"}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "inventoryType":
                    row.minWidth = 220;
                    row.type = 'string';
                    row.filterable = false;
                    row.renderCell = params => {
                        return (
                            <Tooltip title={getInventoryType(params.row)}>
                                <Typography>{getInventoryType(params.row)}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "skuId":
                    row.minWidth = 200;
                    row.type = 'string';
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.skuId ? params.row.skuId : "NA"}>
                                <Typography>{params.row.skuId ? params.row.skuId : "NA"}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "currentWeight":
                    row.minWidth = 150;
                    row.type = 'number';
                    row.filterable = false;
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.currentWeight > 0 ? params.row.currentWeight : 0}>
                                <Typography>{params.row.currentWeight > 0 ? params.row.currentWeight : 0}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "currentFineWeight":
                    row.minWidth = 150;
                    row.filterable = false;
                    row.type = 'number';
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.currentFineWeight > 0 ? params.row.currentFineWeight : 0}>
                                <Typography>{params.row.currentFineWeight > 0 ? params.row.currentFineWeight : 0}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "availableStock":
                    row.minWidth = 150;
                    row.type = 'number';
                    row.filterable = false;
                    row.renderCell = params => {
                        return params.row.availableStock ? params.row.availableStock : "NA"
                    }
                    break;
                case "dimensions":
                    row.minWidth = 100;
                    row.type = 'string';
                    row.filterable = false;
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.dimensions ? params.row.dimensions : "NA"}>
                                <Typography>{params.row.dimensions ? params.row.dimensions : "NA"}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "shape":
                    row.minWidth = 100;
                    row.type = 'string';
                    row.filterable = false;
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.shape ? params.row.shape : "NA"}>
                                <Typography>{params.row.shape ? params.row.shape : "NA"}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "quantity":
                    row.minWidth = 100;
                    row.type = 'number';
                    row.filterable = false;
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.quantity > 0 ? params.row.quantity : 0}>
                                <Typography>{params.row.quantity > 0 ? params.row.quantity : 0}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "purity":
                    row.minWidth = 100;
                    row.type = 'number';
                    row.filterable = false;
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.purity ? params.row.purity : "NA"}>
                                <Typography>{params.row.purity ? params.row.purity : "NA"}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "transactionDetails":
                    row.minWidth = 150;
                    row.filterable = false;
                    row.filterable = false;
                    row.renderCell = params => {
                        let transactionDetails = params.row.transactionDetails
                        return <>{transactionDetails ?
                            <Tooltip title='View transaction Details'>
                                <IconButton style={{ marginLeft: '-10px' }} onClick={() => setShowTranscationDetail(transactionDetails)}><VisibilityIcon /></IconButton>
                            </Tooltip> : "NA"
                        }</>
                    }
                    break;
                case "metalType":
                    row.minWidth = 100;
                    row.type = 'string';
                    row.filterable = false;
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.metalType ? params.row.metalType : "NA"}>
                                <Typography>{params.row.metalType ? params.row.metalType : "NA"}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "weight":
                    row.minWidth = 180;
                    row.type = 'number';
                    row.filterable = false;
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.currentWeight ? params.row.currentWeight : 'NA'}>
                                <Typography>{params.row.currentWeight ? params.row.currentWeight : 'NA'}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "transferredWeight":
                    row.minWidth = 200;
                    row.type = 'number';
                    row.filterable = false;
                    row.headerAlign = 'left';
                    row.renderCell = params => {
                        return <>{
                            (params.row.inventoryType !== 1 && params.row.inventoryType !== 7) ?
                                <TextField
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    value={rowSelectionModel.includes(params.row.id) && params.row.transferredWeight !== 0 ? params.row.transferredWeight : ''}
                                    onChange={(e) => handleWeightTransfer(e, params.row)}
                                    onKeyDown={(e) => e.stopPropagation()}
                                    type={'number'}
                                    disabled={!rowSelectionModel.includes(params.row.id) || params.row.inventoryType === 4 || params.row.inventoryType === 5 || params.row.inventoryType === 6}
                                />
                                :
                                <TextField
                                    disabled
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    value={rowSelectionModel.includes(params.row.id) && params.row.transferredWeight !== 0 ? params.row.transferredWeight : ''}
                                    type={'number'}
                                />
                        }
                        </>
                    }
                    break;
                case "transferredQuantity":
                    row.filterable = false;
                    row.minWidth = 200;
                    row.type = 'number';
                    row.headerAlign = 'left';
                    row.renderCell = params => {
                        return <>{
                            <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                value={rowSelectionModel.includes(params.row.id) && params.row.transferredQuantity !== 0 ? params.row.transferredQuantity : ''}
                                onChange={(e) => handleQuantityTransfer(e, params.row)}
                                type={'number'}
                                disabled={!rowSelectionModel.includes(params.row.id)}
                            />
                        }
                        </>
                    }
                    break;
                case "serialNumbers":
                    row.filterable = false;
                    row.minWidth = 150;
                    row.filterable = false;
                    row.renderCell = params => {
                        return <>{
                            params.row.inventoryType === 1 && rowSelectionModel.includes(params.row.id)
                                ? <Tooltip title='Select Serial Numbers'>
                                    <IconButton style={{ marginLeft: '-10px' }} onClick={() => setSelectSerialNumberModal(params.row)}><VisibilityIcon /></IconButton>
                                </Tooltip>
                                : params.row.inventoryType === 1 ?
                                    <Tooltip title='View Serial Numbers'>
                                        <IconButton style={{ marginLeft: '-10px' }} onClick={() => setShowSerialNumberModal(params.row)}><VisibilityIcon /></IconButton>
                                    </Tooltip>
                                    : "NA"
                        }</>
                    }
                    break;
                default:
                    row.minWidth = 100
                    break;
            }
            return row;
        })
    }

    const handleSelection = () => {
        let updatedRow: InventoryData[] = []

        stoInventories.data.forEach((row: InventoryData) => {
            row['isEditable'] = true
            updatedRow.push(row as InventoryData)
        })
    }

    const clearPreviousRowDetails = () => {
        let updatedRows: InventoryData[] = []

        rows.forEach((row: InventoryData) => {
            row['silverFineWeight'] = 0
            row['goldFineWeight'] = 0
            row['transferredWeight'] = 0
            row['remarks'] = ''
            row['transferredQuantity'] = 0
            row['fineWeightChange'] = 0
            row['selectedSerialNumbers'] = []
            row['selectedRowIds'] = []
            updatedRows.push(row as InventoryData)
        })
        setRows(updatedRows as InventoryData[])
        setTotalGoldFineWeight(0 as number)
        setTotalSilverFineWeight(0 as number)
    }

    const handleRowSelectionModel = (newRowSelectionModel: GridRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);

        // Update rows logic
        if (newRowSelectionModel?.length) {
            const updatedRows: InventoryData[] = [];

            rows.forEach(row => {
                if (newRowSelectionModel.includes(row.id)) {
                    updatedRows.push({ ...row });
                } else {
                    delete row.transferredWeight;
                    delete row.remarks;
                    delete row.transferredQuantity;
                    delete row.fineWeightChange;

                    row.goldFineWeight = 0;
                    row.silverFineWeight = 0;
                    row.selectedSerialNumbers = [];
                    row.selectedRowIds = [];

                    updatedRows.push({ ...row });
                }
            });

            getTotalFineWeight(updatedRows);
            setRows(updatedRows);
        } else {
            clearPreviousRowDetails();
            reloadRGPInventory();
        }
    }

    const reloadRGPInventory = () => {
        let body = {
            channelId: user.centerId! || '',
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            filterModel: filterModel
        }

        execute(() => fetchStoInventory(body)).then(res => setRows(res.data?.data as InventoryData[]))
    }

    const onFilterChange = useCallback((filterModel: GridFilterModel) => {
        setFilterModel(filterModel)
    }, [])

    const handleCustomer = () => {
        setShowCustomerModal(prev => !prev)
        setBillingAddressId('')
        setShippingAddressId('')
    }

    const closeCustomerSelection = () => {
        setShowCustomerModal(prev => !prev)
    }

    const handleCustomerSelection = (e: { target: { checked: boolean } }) => {
        setExistingCustomerSelected(e.target.checked)
        setCustomerAddresses([])
        setBillingAddressId('')
        setShippingAddressId('')
        setCustomerName('')
        setMobileNumber('')
        setRGPCustomerAddress([])
        setCreateNewAddress(false)
    }

    const handleMobileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setMobileNumber(value);

        if (/^\d{10}$/.test(value)) {
            handleRGPCustomerSearch(value);
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            handleRGPCustomerSearch(mobileNumber);
        }
    }

    const handleRGPCustomerSearch = async (value: string) => {
        if (createNewAddress) return

        if (/^\d{10}$/.test(value)) {
            let { data, error } = await execute(() => searchRGPCustomer({ mobileNumber: value }))

            if (!data.length) return notify('Existing RGP customer not found!');
            if (error) return notify('Unable to find RGP customer', 'error')
        } else {
            notify('Please enter a valid 10-digit mobile number.');
        }
    }

    const handleAddressCreate = () => {
        setCreateNewAddress(prev => !prev)
        setRGPCustomerAddress([])
        setBillingAddressId('')
        setShippingAddressId('')
        setCustomerName('')
        setMobileNumber('')
    }

    const createRGPOrder = async () => {
        if (rowSelectionModel && !rowSelectionModel.length)
            return notify('Please select Inventory and update values!', "error")

        if (isExistingCustomerSelected) {
            if (isShippingBillingAddressSame) {
                if (!billingAddressId)
                    return notify('Please select Billing address Location to transfer RGP!', "error")
            } else {
                if (!billingAddressId && !shippingAddressId)
                    return notify('Please select Billing and Shipping address Location to transfer RGP!', "error")
            }
        } else {
            if (isShippingBillingAddressSame) {
                if (!Object.keys(userAddress.billingAddress).length)
                    return notify('Please select Billing address Location to transfer RGP!', "error")
            } else {
                if (!Object.keys(userAddress.billingAddress).length && !Object.keys(userAddress.shippingAddress).length)
                    return notify('Please select Billing and Shipping address Location to transfer RGP!', "error")
            }
        }

        if (!isExistingCustomerSelected && !customerName && !mobileNumber) {
            return notify('Please fill the user details!', "error")
        }

        const editedRow = rows.filter((row: InventoryData) => rowSelectionModel.some((id) => id === row.id))

        const payload: any = {
            inventoryLineItems: editedRow,
            total_gold_fine_weight: totalGoldFineWeight,
            total_silver_fine_weight: totalSilverFineWeight,
            userAddress: isExistingCustomerSelected
                ? userAddress
                : { ...userAddress, billingAddress: { name: customerName, mobileNumber, ...userAddress.billingAddress }, shippingAddress: { name: customerName, mobileNumber, ...userAddress.shippingAddress } },
            isShippingBillingAddressSame: isShippingBillingAddressSame,
            isExistingCustomer: isExistingCustomerSelected,
            remarks,
        }

        let { data, error } = await execute(() => createRGPTransferOrder(payload))

        if (!error) {
            notify('RGP transferred successfully!')
            onClose()
            reloadRGPInventory()
            reloadRGPData()
        }
    }

    useEffect(() => {
        if (isExistingCustomerSelected) {
            const billingAddressObj = customerAddresses.find(address => address.id === billingAddressId);
            const shippingAddressObj = isShippingBillingAddressSame
                ? billingAddressObj
                : customerAddresses.find(address => address.id === shippingAddressId);

            setUserAddress((prev: any) => ({
                ...prev,
                billingAddress: billingAddressObj,
                shippingAddress: shippingAddressObj
            }))
        }
    }, [
        isExistingCustomerSelected,
        isShippingBillingAddressSame,
        billingAddressId,
        shippingAddressId,
        customerAddresses
    ])

    useEffect(() => {
        handleSelection()
    }, [])

    useEffect(() => {
        reloadRGPInventory()
    }, [paginationModel, filterModel.items[0]?.value])

    const formattedAddress = isExistingCustomerSelected
        ? customerAddresses.map((addr: any) => ({ 'label': `${addr.name} - ${addr.line1}, ${addr.city}, ${addr.state}`, 'value': addr.id }))
        : getRGPCustomerAddress?.length && getRGPCustomerAddress.map((addr: any) => ({ 'label': `${addr.name} - ${addr.line1}, ${addr.city}, ${addr.state}`, 'value': addr.id }))

    let columns = getInventoryColumns()

    return (
        <Container style={{ padding: '10px' }}>
            <Stack width="100%" direction="row" marginBottom={"10px"}>
                <FormControlLabel
                    sx={{ color: "#7f7d76" }}
                    control={
                        <Checkbox
                            size='small'
                            onChange={handleCustomerSelection}
                            checked={isExistingCustomerSelected}
                        />
                    }
                    label='Select existing customer'
                />
            </Stack>
            <Divider />

            <Box marginTop={"25px"}>
                {isExistingCustomerSelected ?
                    <>
                        <Stack width="100%" direction="row" gap="25px" align-items="center">
                            <Box style={{ borderBottom: '1px solid #f1f1f1', color: '#7f7d76', paddingBottom: '1.5%', marginBottom: "20px" }}>
                                <Button variant={'contained'} onClick={handleCustomer}>{'Existing Customer'}</Button>
                            </Box>
                            {customerAddresses.length ?
                                <TextField
                                    disabled
                                    required
                                    size="small"
                                    label="Customer Name"
                                    value={customerAddresses[0]?.name}
                                    variant="outlined"
                                    sx={{ width: '50ch' }}
                                />
                                : null
                            }
                        </Stack>

                        <Stack width="100%" direction="row" gap="25px" align-items="center" marginBottom={"20px"}>
                            <FormControl required fullWidth size='small' sx={{ width: 525 }}>
                                <InputLabel id={`billing_address Address`}>Billing Address</InputLabel>
                                <Select
                                    required
                                    labelId={`billing_address`}
                                    label='Billing Address'
                                    value={billingAddressId}
                                    onChange={(e) => setBillingAddressId(e.target.value)}
                                >
                                    {formattedAddress?.map((option: any, index: any) => {
                                        return <MenuItem key={index} value={option.value}>{option.label}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                            <FormControl required fullWidth size='small' sx={{ width: 525 }}>
                                <InputLabel id={`ahipping_address`}>Shipping Address</InputLabel>
                                <Select
                                    required
                                    labelId={`ahipping_address`}
                                    label='Shipping Address'
                                    value={isShippingBillingAddressSame ? billingAddressId : shippingAddressId}
                                    disabled={isShippingBillingAddressSame}
                                    onChange={(e) => setShippingAddressId(e.target.value)}
                                >
                                    {formattedAddress?.map((option: any, index: any) => {
                                        return <MenuItem key={index} value={option.value}>{option.label}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                            <FormControlLabel
                                sx={{ color: "#7f7d76" }}
                                control={
                                    <Checkbox
                                        size='small'
                                        onChange={(e, checked) => setShippingBillingAddressSame(checked)}
                                        checked={isShippingBillingAddressSame}
                                    />
                                }
                                label='is Shipping same As Billing Address'
                            />
                        </Stack>
                        <Stack width="100%" direction="row" gap="25px" align-items="center" marginBottom={"25px"}>
                            <Box style={{ width: 'calc(50% - 10px)' }}>
                                {billingAddressId
                                    ? <AddressCard address={customerAddresses.filter(address => address.id === billingAddressId)[0]} heading='Billing Address' />
                                    : <></>
                                }
                            </Box>
                            {!isShippingBillingAddressSame && <Box style={{ width: 'calc(50% - 10px)' }}>
                                {shippingAddressId
                                    ? <AddressCard address={customerAddresses.filter(address => address.id === shippingAddressId)[0]} heading='Shipping Address' />
                                    : <></>
                                }
                            </Box>}
                        </Stack>
                    </>
                    :
                    <>
                        <Stack width="100%" direction="row" alignItems="center" gap="25px" align-items="center" marginBottom={createNewAddress ? "25px" : "10px"}>
                            <TextField
                                required
                                size="small"
                                label="Mobile Number"
                                value={mobileNumber}
                                variant="outlined"
                                sx={{ width: '30ch' }}
                                onChange={handleMobileChange}
                                onKeyDown={handleKeyDown}
                            />
                            <TextField
                                disabled={createNewAddress ? false : true}
                                required
                                size="small"
                                label="Customer Name"
                                value={!createNewAddress && getRGPCustomerAddress?.length ? getRGPCustomerAddress[0]?.name : customerName}
                                variant="outlined"
                                sx={{ width: '50ch' }}
                                onChange={(e) => setCustomerName(e.target.value)}
                            />
                            {createNewAddress &&
                                <FormControlLabel
                                    sx={{ color: "#7f7d76", width: 450 }}
                                    control={
                                        <Checkbox
                                            size='small'
                                            onChange={(e, checked) => setShippingBillingAddressSame(checked)}
                                            checked={isShippingBillingAddressSame}
                                        />
                                    }
                                    label='is Shipping same As Billing Address'
                                />
                            }
                            {/* <Typography variant="subtitle1" display="block">{'OR'}</Typography> */}
                            <Button color="primary" variant="contained" onClick={handleAddressCreate} >
                                {createNewAddress ? 'Search customer' : 'Create new address'}
                            </Button>
                        </Stack>
                        {!createNewAddress && <Typography variant="caption" display="block" marginBottom="25px">
                            {'Note: Search RGP customer using mobile number.'}
                        </Typography>}
                        {!createNewAddress ?
                            <>
                                <Stack width="100%" direction="row" gap="25px" align-items="center" marginBottom={"20px"}>
                                    <FormControl required fullWidth size='small' sx={{ width: 525 }}>
                                        <InputLabel id={`billing_address Address`}>Billing Address</InputLabel>
                                        <Select
                                            required
                                            labelId={`billing_address`}
                                            label='Billing Address'
                                            value={billingAddressId}
                                            onChange={(e) => setBillingAddressId(e.target.value)}

                                        >
                                            {formattedAddress.length && formattedAddress?.map((option: any, index: any) => {
                                                return <MenuItem key={index} value={option.value}>{option.label}</MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                    <FormControl required fullWidth size='small' sx={{ width: 525 }}>
                                        <InputLabel id={`ahipping_address`}>Shipping Address</InputLabel>
                                        <Select
                                            required
                                            labelId={`ahipping_address`}
                                            label='Shipping Address'
                                            value={isShippingBillingAddressSame ? billingAddressId : shippingAddressId}
                                            disabled={isShippingBillingAddressSame}
                                            onChange={(e) => setShippingAddressId(e.target.value)}
                                        >
                                            {formattedAddress.length && formattedAddress?.map((option: any, index: any) => {
                                                return <MenuItem key={index} value={option.value}>{option.label}</MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                    <FormControlLabel
                                        sx={{ color: "#7f7d76" }}
                                        control={
                                            <Checkbox
                                                size='small'
                                                onChange={(e, checked) => setShippingBillingAddressSame(checked)}
                                                checked={isShippingBillingAddressSame}
                                            />
                                        }
                                        label='is Shipping same As Billing Address'
                                    />
                                </Stack>
                                <Stack width="100%" direction="row" gap="25px" align-items="center" marginBottom={"25px"}>
                                    <Box style={{ width: 'calc(50% - 10px)' }}>
                                        {billingAddressId
                                            ? <AddressCard address={getRGPCustomerAddress.filter((address: any) => address.id === billingAddressId)[0]} heading='Billing Address' />
                                            : <></>
                                        }
                                    </Box>
                                    {!isShippingBillingAddressSame && <Box style={{ width: 'calc(50% - 10px)' }}>
                                        {shippingAddressId
                                            ? <AddressCard address={getRGPCustomerAddress.filter((address: any) => address.id === shippingAddressId)[0]} heading='Shipping Address' />
                                            : <></>
                                        }
                                    </Box>}
                                </Stack>
                            </>
                            : createNewAddress &&
                            <Stack width="100%" direction="row" gap="25px" align-items="center" marginBottom={"20px"}>
                                <Box style={{ width: 'calc(50% - 10px)' }}>
                                    <AddressCardMannual addressForm={BILLING_ADDRESS_DETAILS_FORM} setUserAddress={setUserAddress} isSameAddress={isShippingBillingAddressSame} heading='Billing Address' type='billingAddress' />
                                </Box>
                                {!isShippingBillingAddressSame && <Box style={{ width: 'calc(50% - 10px)' }}>
                                    <AddressCardMannual addressForm={SHIPPING_ADDRESS_DETAILS_FORM} setUserAddress={setUserAddress} isSameAddress={isShippingBillingAddressSame} heading='Shipping Address' type='shippingAddress' />
                                </Box>}
                            </Stack>
                        }
                    </>
                }
            </Box>

            <Table
                fixHeight={500}
                editMode="row"
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                rows={rows || []}
                getRowId={(row) => row.id}
                columns={columns}
                checkboxSelection
                disableRowSelectionOnClick
                isRowSelectable={(params: GridRowParams) => params.row.isEditable}
                onRowSelectionModelChange={handleRowSelectionModel}
                rowSelectionModel={rowSelectionModel}
                paginationMode={"server"}
                hideFooter={false}
                rowCount={stoInventories?.count ?? 0}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                    panel: {
                        sx: {
                            '& .MuiDataGrid-filterForm': {
                                flexDirection: 'row',
                            },
                            '& .MuiDataGrid-filterFormValueInput': {
                                minWidth: '1150px',
                            },
                        },
                    },
                }}
                pageSizeOptions={[25, 50, 75, 100, 150]}
                filterMode='server'
                filterDebounceMs={300}
                onFilterModelChange={onFilterChange}
            />

            <Stack width="100%" direction="row" gap="25px" align-items="center">
                <TextField
                    required
                    fullWidth
                    size="small"
                    label="Remarks"
                    multiline
                    rows={1}
                    value={remarks}
                    variant="outlined"
                    onChange={(e) => setRemarks(e.target.value)}
                    sx={{ marginTop: '25px' }}
                />
            </Stack>

            <TextFieldGroup>
                <Box sx={{ display: 'flex', alignItems: 'center', width: '500px' }}>
                    <Typographyfield>{'Total Gold fine Weight'}</Typographyfield> :
                    <TypographyValue>{totalGoldFineWeight.toFixed(3)} gm</TypographyValue>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', width: '500px' }}>
                    <Typographyfield>{'Total Silver Fine Weight'}</Typographyfield> :
                    <TypographyValue>{totalSilverFineWeight.toFixed(3)} gm</TypographyValue>
                </Box>
            </TextFieldGroup>

            <Stack width="100%" marginTop="25px" direction="row" justifyContent="flex-end" gap="10px" align-items="center">
                <Button onClick={onClose}>Cancel</Button>
                <Button color="primary" variant="contained" onClick={createRGPOrder} disabled={!remarks}>Submit</Button>
            </Stack>
            <Modal open={typeof showTranscationDetail != 'boolean'} title={'View Transcation Details'} onClose={closeTranscationDetailModal} maxWidth={'xl'}>
                <ShowTranscationDetails data={showTranscationDetail} />
            </Modal>
            <Modal open={typeof showSerialNumberModal != 'boolean'} title={'view Serial Numbers'} onClose={closeSerialNumberModal} maxWidth={'xl'}>
                <ShowSerialNumbers data={showSerialNumberModal} />
            </Modal>
            <Modal open={typeof selectSerialNumberModal != 'boolean'} title={'Select Serial Numbers'} onClose={closeSelectSerialNumberModal} maxWidth={'xl'}>
                <ShowMetalSerialNumbers currentRow={selectSerialNumberModal} allRows={rows} setUpdatedRow={setRows} handleQuantity={handleQuantityTransfer} />
            </Modal>
            <Modal onClose={closeCustomerSelection} open={showCustomerModal} title="Customer Selection" >
                <SelectCustomer type={RGPStockModal} onClose={closeCustomerSelection} />
            </Modal>
        </Container>
    )
}

export default CreateRGPModal



export function ShowMetalSerialNumbers({ currentRow, allRows, setUpdatedRow, handleQuantity }: { currentRow: InventoryData | boolean, allRows: InventoryData[], setUpdatedRow: Function, handleQuantity: Function }) {
    let { id, skuId, name, currentWeight, quantity, metalType, serialNumbers } = currentRow as InventoryData

    const [serialNumberRows, setSerialNumberRows] = useState([])
    const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 10,
        page: 0,
    });

    useEffect(() => {
        let updatedRows = JSON.parse(serialNumbers).map((item: any, idx: any) => {
            return {
                id: idx,
                skuId: skuId,
                name: name,
                currentWeight: Number((currentWeight / quantity).toFixed(3)),
                metalType: metalType,
                serialNumber: item
            }
        })
        setSerialNumberRows(updatedRows as any)

        let currentSelectedRow = allRows.find((row: InventoryData) => row.id === id)
        setRowSelectionModel(currentSelectedRow?.selectedRowIds as GridRowSelectionModel)
    }, [])

    const handleRowSelection = (rowSelectId: GridRowSelectionModel) => {
        let selectedSerialNumbers: number[] = []
        const selectedIDs = new Set(rowSelectId);

        serialNumberRows.filter((row: any) => selectedIDs.has(row.id))
            .map((row: any) => selectedSerialNumbers.push(row.serialNumber))
        let totalSerialNumbers = selectedSerialNumbers.length

        setUpdatedRow((prev: InventoryData[]) => {
            let previousRows = [...prev]
            let idx = previousRows.findIndex((row: InventoryData) => row.id === id)
            previousRows[idx].selectedSerialNumbers = selectedSerialNumbers
            previousRows[idx].selectedRowIds = rowSelectId as number[]
            handleQuantity(totalSerialNumbers, currentRow)
            return previousRows
        })
        setRowSelectionModel(rowSelectId)
    }

    let columns: GridColDef[] = [
        {
            field: "skuId",
            headerName: "SKU ID",
            minWidth: 180,
            renderCell: (params: any) => {
                return params.row.skuId
            }
        },
        {
            field: "name",
            headerName: "SKU Name",
            minWidth: 250,
            renderCell: (params: any) => {
                return params.row.name
            }
        },
        {
            field: "currentWeight",
            headerName: "Unit Weight (gm)",
            minWidth: 150,
            renderCell: (params: any) => {
                return params.row.currentWeight
            }
        },
        {
            field: "metalType",
            headerName: "Metal Type",
            minWidth: 150,
            renderCell: (params: any) => {
                return params.row.metalType
            }
        },
        {
            field: "serialNumber",
            headerName: "Serial Number",
            minWidth: 120,
            renderCell: (params: any) => {
                return params.row.serialNumber
            }
        },
    ]

    return (
        <SerialNumberGrid>
            <DataGrid
                getRowId={(row) => row.id}
                rows={serialNumberRows}
                columns={columns}
                pagination={true}
                paginationMode={"client"}
                rowHeight={40}
                checkboxSelection
                onRowSelectionModelChange={handleRowSelection}
                rowSelectionModel={rowSelectionModel}
                slots={{ toolbar: GridToolbar }}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                sx={{
                    ".MuiDataGrid-columnHeaders":
                    {
                        background: 'var(--primary_color_light)',
                        borderRadius: '0'
                    },
                    border: 'none',
                    borderRadius: '0'
                }}
            />
        </SerialNumberGrid>
    )
}

const AddressCardMannual = (props: { addressForm: any, setUserAddress: any, heading: string, type: string, isSameAddress: boolean }) => {
    const { addressForm, setUserAddress, type, heading, isSameAddress } = props
    const { registerForm, setFormData, formData, setField } = useDynamicForm({ formConfig: addressForm })

    useEffect(() => {
        setUserAddress((prev: any) => {
            const updated = { ...prev };

            if (type === 'billingAddress') {
                updated.billingAddress = { ...(formData as Record<string, any>) };
                if (isSameAddress) {
                    updated.shippingAddress = { ...(formData as Record<string, any>) };
                }
            }

            if (type === 'shippingAddress' && !isSameAddress) {
                updated.shippingAddress = { ...(formData as Record<string, any>) };
            }

            return updated;
        });

    }, [formData, isSameAddress, type, setUserAddress])

    return (
        <div style={{ border: '1px solid silver', borderRadius: '10px', color: 'var(--text_color_2)' }}>
            <h3 style={{ color: 'var(--text_color_2)', background: '#f1f1f1', padding: '10px', borderRadius: '10px 10px 0 0' }}>{heading}</h3>
            <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                <DynamicForm {...registerForm()} onSubmit={() => ({})} submitText={null} />
            </div>
        </div>
    )
}